import React, { useState } from 'react';
import GlobalFilterPanel from '../filter/GlobalFilterPanel';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

const DEFAULT_FILTER_SETTING = {
    hideElements: {
        month: true,
        year: true,
        returnType: true,
        returnStatus: true
    }
};

const FilterPanel = ({ onSearchClick, countries }) => {
    const [selection, setSelection] = useState({
        ledgerType: "0"
    });

    const onLedgerTypeChange = (event) => {
        let selection = Object.assign({}, selection, {ledgerType: event.target.value});
        setSelection(selection);
    }

    const handleSearchClick = (filters) => {
        let combinedSelection = Object.assign({}, filters, { ledgerType: selection.ledgerType });
        onSearchClick(combinedSelection);
    }

    return (
        <s-box name="filter-panel" data-testid="sales_filter_panel">
            <GlobalFilterPanel
                {...DEFAULT_FILTER_SETTING}
                onSearchClick={handleSearchClick}
                countries={countries}
            >
                <fieldset data-testid="ledgerType-container" role="radiogroup" aria-labelledby="ledgerType">
                    <legend id="ledgerType">
                        <span><LanguageStringResolver string='salesAndPurchase_LedgerType' /></span>
                    </legend>
                    <span class="clear" />
                    <input
                        type="radio"
                        id="sales"
                        data-testid="sales-radio"
                        name="type"
                        value="0"
                        checked={selection.ledgerType === "0"}
                        onChange={onLedgerTypeChange}
                    />
                    <label class="radio" for="r4"><LanguageStringResolver string='salesAndPurchase_Sales' /></label>
                    <input
                        type="radio"
                        id="purchase"
                        data-testid="purchase-radio"
                        name="type"
                        value="1"
                        checked={selection.ledgerType === "1"}
                        onChange={onLedgerTypeChange}
                    />
                    <label class="radio" for="r6"><LanguageStringResolver string='salesAndPurchase_Purchase' /></label>
                </fieldset>
            </GlobalFilterPanel>
        </s-box>
    )
}

export default FilterPanel;